export interface Testimonial {
  id: string;
  name: string;
  role?: string;
  company?: string;
  project?: string;
  category?: string;
  quote: string;
  /** Optional short highlight metric shown on the card. */
  metric?: string;
  inProgress?: boolean;
  /** Case-study slug this client maps to (for the WhatsApp note on that page). */
  caseSlug?: string;
  /** Short, casual WhatsApp-style message shown on the case study. */
  note?: string;
  /** Timestamp shown on the client's WhatsApp bubble. */
  noteTime?: string;
  /** DotSlashLab's reply shown as an outgoing WhatsApp bubble. */
  reply?: string;
  /** Timestamp shown on the reply bubble. */
  replyTime?: string;
}

// Client testimonials. Names and titles supplied by the clients; quotes written
// with DotSlashLab and approved for publication.
export const testimonials: Testimonial[] = [
  {
    id: "01",
    name: "Umair Mukadam",
    role: "Founder & CEO",
    company: "PathPulse",
    project: "PathPulse",
    category: "Public Sector · Payments",
    quote:
      "Aaditya and the team felt like part of our own from day one. We trusted them with settlement rails a government depends on, and they delivered something fast, low cost and fully auditable. Beyond the work, they genuinely cared that we succeeded.",
    metric: "Dual chain govt rails",
    caseSlug: "pathpulse",
    note: "Honestly can't thank you and the team enough 🙏 the rails are rock solid. You made something really hard feel easy.",
    noteTime: "10:24 AM",
    reply: "Means the world coming from you Umair 🙏 it was an honour building this with you. Always here whenever you need us 💙",
    replyTime: "10:31 AM",
  },
  {
    id: "02",
    name: "Sandeep Rathore",
    role: "Founder & Director",
    company: "Adcotel",
    project: "Adcotel",
    category: "Travel Tech · Booking",
    quote:
      "Working with Aaditya has been less like hiring a studio and more like gaining a partner. DotSlashLab rebuilt our app, web and backend without missing a beat, and they were always just a message away. That kind of trust is rare.",
    metric: "Full platform rebuild",
    caseSlug: "adcotel",
    note: "App and web are running beautifully 🚀 you guys felt like our own team the whole way through. Thank you!",
    noteTime: "8:47 PM",
    reply: "Thank you Sandeep 🙌 you trusted us with the whole thing and that meant a lot. Excited for what's next together 🚀",
    replyTime: "8:52 PM",
  },
  {
    id: "03",
    name: "Vinayak Pandey",
    role: "Point of Contact",
    company: "Government of Maharashtra",
    project: "Maharashtra Govt",
    category: "Public Sector · Government",
    quote:
      "It has been a genuine pleasure working with Aaditya and the DotSlashLab team. They understand the reliability and compliance we have to meet, they communicate openly, and the progress so far has been very reassuring. A team you can count on.",
    inProgress: true,
    caseSlug: "maharashtra-govt",
    note: "Really appreciate how smoothly things are moving 👍 your team understands the compliance side like no one else. Looking forward to the rest.",
    noteTime: "4:12 PM",
    reply: "Thank you so much 🙏 it is a privilege working with your team. We will hold the same standard all the way through 💪",
    replyTime: "4:20 PM",
  },
  {
    id: "04",
    name: "Ankit Shah",
    role: "Founder & Partner",
    company: "Chatlio",
    project: "Chatlio",
    category: "Gaming · Automation",
    quote:
      "DotSlashLab built our casino app and web platform, and then stayed on to automate the operations too. Aaditya and the team treat our product like it is their own, and that loyalty has meant everything to us.",
    metric: "Product to operations partner",
    caseSlug: "chatlio",
    note: "The automation is a game changer for us 🙌 you didn't just build it, you stuck around to make it run. Means a lot 🙏",
    noteTime: "11:38 PM",
    reply: "Appreciate you Ankit 🙏 your product feels like ours too. Let's keep making it better together 🙌",
    replyTime: "11:46 PM",
  },
  {
    id: "05",
    name: "Ragul Vasudevan",
    role: "Product Manager",
    company: "Yap.market",
    project: "Yap.market",
    category: "Web3 · Prediction Markets",
    quote:
      "Aaditya and his team built our platform and prediction marketplace with real heart. We scaled past 10K users and raised 5M dollars, and through all of it they felt like teammates, not vendors.",
    metric: "10K+ users · $5M raised",
    caseSlug: "yap-market",
    note: "We crossed 10k users 🎉 couldn't have done it without you and the team. You guys felt like real teammates throughout 💪",
    noteTime: "2:05 PM",
    reply: "Huge congrats on 10k 🎉 you and the team made it easy to care. Onwards and upwards 🚀",
    replyTime: "2:11 PM",
  },
  {
    id: "06",
    name: "Harshal Madnani",
    role: "Founder",
    company: "Xade Finance",
    project: "Xade Finance",
    category: "Fintech · Prop Trading",
    quote:
      "The DotSlashLab team understood capital markets better than most, but what stayed with me is how personally invested Aaditya was in our success. The product helped us raise 23M dollars, and I would call them again in a heartbeat.",
    metric: "$23M raised",
    caseSlug: "xade-finance",
    note: "Closed the 23M round 🔥 the product you built carried so much of it. Forever grateful, will always come back to you guys 🙏",
    noteTime: "9:21 PM",
    reply: "Congrats on the raise Harshal 🔥 so proud of what you have built. We are always just a message away 🙏",
    replyTime: "9:28 PM",
  },
  {
    id: "07",
    name: "Achintya Singh",
    role: "Founder & Creator",
    company: "BoardlyX",
    project: "BoardlyX",
    category: "AI + Web3 · Productivity",
    quote:
      "Aaditya and the team took on a big ask and delivered one clean workspace for everything we needed. They were patient, honest and genuinely excited about what we were building. It never once felt transactional.",
    metric: "4 in 1 workspace shipped",
    caseSlug: "boardlyx",
    note: "It all just works, chat, boards, analytics, on-chain, everything in one place 🤯 you nailed it. Thanks for the patience 🙏",
    noteTime: "7:54 PM",
    reply: "Thank you Achintya 🙏 loved building this with you. You were a dream to work with 🙌",
    replyTime: "8:02 PM",
  },
  {
    id: "08",
    name: "Jayesh Rathod",
    role: "CTO",
    company: "EasyHyr",
    project: "EasyHyr",
    category: "AI · Job Matching",
    quote:
      "As a CTO I care about what is under the hood, and DotSlashLab built it properly. Just as important, Aaditya and the team were a joy to work with, always open, always in our corner.",
    metric: "End to end AI pipeline",
    caseSlug: "easyhyr",
    note: "As a CTO I'm genuinely impressed 👏 the pipeline is clean under the hood. And you shipped way faster than I expected. Respect 🙌",
    noteTime: "1:16 PM",
    reply: "That means a lot coming from a CTO 🙏 thank you Jayesh. Always happy to go deep on the hard parts with you 💪",
    replyTime: "1:23 PM",
  },
  {
    id: "09",
    name: "Rahul Singhania",
    role: "CTO",
    company: "Astra Finance",
    project: "Astra Finance",
    category: "DeFi · StarkNet",
    quote:
      "Audit ready StarkNet code with institutional grade UX is hard to find, and DotSlashLab gave us both. Working with Aaditya felt like working with a friend who happens to be a brilliant engineer.",
    metric: "$50M+ TVL secured",
    caseSlug: "astra-finance",
    note: "Audit ready and the UX is 🔥 honestly felt like working with a friend, not a vendor. TVL is holding strong 💪",
    noteTime: "6:03 PM",
    reply: "Thanks Rahul 🙏 the friendship made the work better. Here for the next build whenever you are 💙",
    replyTime: "6:10 PM",
  },
  {
    id: "10",
    name: "Jay Kapoor",
    role: "Founder & CTO",
    company: "Echo AI",
    project: "Echo AI",
    category: "Enterprise AI",
    quote:
      "We needed real workflow orchestration, not a demo, and the team delivered a measurable efficiency gain. Beyond the technology, Aaditya built a relationship with us that we truly value.",
    metric: "30% efficiency gain",
    caseSlug: "echo-ai",
    note: "The efficiency gain is real 📈 you built exactly what we needed, not a demo. Really value the relationship we've built 🙏",
    noteTime: "3:42 PM",
    reply: "Appreciate you Jay 🙏 glad the numbers are showing. The relationship means just as much to us 🙌",
    replyTime: "3:49 PM",
  },
  {
    id: "11",
    name: "Abhishek Tiwari",
    role: "Product Head",
    company: "PP Editor",
    project: "PP Editor",
    category: "AI · Media",
    quote:
      "Our workflow got roughly 10x faster after DotSlashLab rebuilt it, but what our team remembers is how personal the whole process felt. Aaditya and the team genuinely care, and it shows in everything they ship.",
    metric: "10x faster workflow",
    caseSlug: "pp-editor",
    note: "Workflow is like 10x faster now 😮 the whole team noticed instantly. You made it feel so personal too, thank you 🙌",
    noteTime: "5:29 PM",
    reply: "Thank you Abhishek 🙌 so glad the team feels it. Making it personal is the whole point 💙",
    replyTime: "5:36 PM",
  },
  {
    id: "12",
    name: "Aaditya Singh",
    role: "Founder & CEO",
    company: "GitCode V3",
    project: "GitCode V3",
    category: "Developer Platform",
    quote:
      "The DotSlashLab team unified a messy developer workflow into one platform our team actually enjoys using. They were thoughtful, responsive and easy to trust the whole way through. It felt like family, not a handoff.",
    metric: "Unified dev workflow",
    caseSlug: "gitcode-v3",
    note: "The team actually enjoys using it now 😄 one clean platform for everything. Smooth build, easy to trust. Thanks a ton 🙏",
    noteTime: "10:11 AM",
    reply: "Thank you 🙏 nothing better than a team that enjoys the tool. Grateful for the trust 🙌",
    replyTime: "10:18 AM",
  },
];

// Wider-community / third-party voices. Founders and peers who have seen how the
// studio works, not tied to a single engagement above.
export const communityVoices: Testimonial[] = [
  {
    id: "c01",
    name: "Aditya Tiwari",
    role: "Founder",
    company: "Tegacy.ai",
    quote:
      "I have watched Aaditya and DotSlashLab closely, and what sets them apart is heart. They move fast, they keep their word, and they treat every project like it is their own. Good people building good things.",
  },
  {
    id: "c02",
    name: "Meet Parekh",
    role: "Founder",
    quote:
      "DotSlashLab is a reliable team that turns ideas into well built, production ready products. They are responsive, professional and deliver exactly what they promise. Highly recommend working with them.",
  },
  {
    id: "c03",
    name: "Kartik Chaurasiya",
    role: "Full Stack Engineer",
    quote:
      "What I love about Aaditya and the DotSlashLab team is how much they cover, AI, blockchain, full stack, and still stay warm and dependable through it all. A team you want in your corner.",
  },
];

// Lookup helper: the client note for a given case-study slug.
export const noteForCase = (slug: string): Testimonial | undefined =>
  testimonials.find((t) => t.caseSlug === slug && t.note);
